{
  "overridesEnabledBadgeLabel": "Remplacements sur",
  "releaseBadgeAlpha": "Alpha",
  "releaseBadgeBeta": "Bêta",
  "releaseBadgeDev": "Dév.",
  "releaseBadgePoc": "PdC"
}
